export default "__VITE_ASSET__D8QteKut__"